import { useSiteSettings } from "./SiteSettingsContext";

/*
 * Whether marketing copy may promise a free signup.
 *
 * Admin -> Settings has separate Free-plan switches for men and women. Copy
 * that every visitor sees (CTAs, FAQs, banners) may only say "free" when
 * BOTH are on; otherwise a man would be promised something we don't offer.
 * Pass a gender when the reader is known (e.g. a logged-in member).
 */
export const isFreeOffered = (settings, gender) => {
  const tier = (settings && settings.free_tier) || {};
  const male = tier.male_free_plan_enabled !== false;
  const female = tier.female_free_plan_enabled !== false;
  const g = String(gender || "").toLowerCase();
  if (g === "female") return female;
  if (g === "male") return male;
  return male && female;
};

export const useFreeOffered = (gender) => {
  const ctx = useSiteSettings();
  return isFreeOffered(ctx && ctx.settings, gender);
};

export default useFreeOffered;
